import React from 'react';
import styles from './VendorStoreMenu.module.css';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import FlexChild from 'layouts/flex/FlexChild';

/* 탭버튼 카테고리 */
const categories = [
    {
        name: 'autoOrder',
        text: '자동 발주 내역',
    },
    {
        name: 'calc',
        text: '정산 내역',
    },
    {
        name: 'machine',
        text: '자판기 상태 관리',
    },
    {
        name: 'cctv',
        text: '매장 제어(CCTV)',
    },
];

const VendorStoreMenu = ({ category, onSelect }) => {
    return (
        <HorizontalFlex gap="1rem">
            {categories.map(c => (
                <FlexChild key={c.name}>
                    {' '}
                    {/* FlexChild에 key prop 추가 */}
                    <div
                        className={
                            category === c.name
                                ? styles.activeButton
                                : styles.button
                        }
                        onClick={() => onSelect(c.name)}
                    >
                        {c.text}
                    </div>
                </FlexChild>
            ))}
        </HorizontalFlex>
    );
};

export default VendorStoreMenu;
